import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "panel panel-section request-assigned-panel p-bottom-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "panel-heading request-assigned-panel-header has-background-light has-text-weight-semibold is-size-4" }, " Staff assigned ", -1)
const _hoisted_3 = {
  key: 0,
  class: "request-assigned-panel-content"
}
const _hoisted_4 = {
  key: 0,
  "data-cy": "request-staff"
}
const _hoisted_5 = { class: "panel-item is-flex is-align-items-center is-justify-content-space-between has-text-weight-semibold panel-item--editable" }
const _hoisted_6 = { class: "m-left-8 has-text-red t--strikethrough" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "m-left-8" }
const _hoisted_9 = {
  key: 1,
  class: "m-left-8"
}
const _hoisted_10 = {
  key: 2,
  class: "m-left-8"
}
const _hoisted_11 = { class: "message-contents-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-bold" }, "Send Message (optional)", -1)
const _hoisted_13 = {
  key: 0,
  class: "m-top-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestDepartmentAssigned = _resolveComponent("RequestDepartmentAssigned")!
  const _component_RequestPoc = _resolveComponent("RequestPoc")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrModal = _resolveComponent("NrModal")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_nr_editor = _resolveComponent("nr-editor")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_message_box = _resolveComponent("message-box")!
  const _component_NrLoadingAnimation = _resolveComponent("NrLoadingAnimation")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    (!_ctx.filteredRequestLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_RequestDepartmentAssigned),
          _createVNode(_component_RequestPoc, { poc: $props.poc }, null, 8, ["poc"]),
          ($options.canSeeStaffOnlyItems)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(" Support staff "),
                  ($options.canAddAndRemoveStaff)
                    ? (_openBlock(), _createBlock(_component_NrTooltip, {
                        key: 0,
                        label: "Add support staff"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NrIconButton, {
                            class: "edit-request-assigned-btn",
                            variant: "minimal-neutral",
                            icon: { name: 'plus', type: 'regular' },
                            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.handleAddStaffClick())),
                            "aria-label": "add support staff"
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.requestStaff, (staff, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["is-flex is-align-items-center is-justify-content-space-between panel-item", $options.canAddAndRemoveStaff ? 'panel-item--editable' : 'p-bottom-8']),
                    key: index
                  }, [
                    (staff.undeliverable_email)
                      ? (_openBlock(), _createBlock(_component_NrTooltip, {
                          key: 0,
                          label: "Mail to this address has been returned as undeliverable"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_6, _toDisplayString($options.staffNameOrEmail(staff)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (staff && staff.departments.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            ($options.staffDepartmentsWithPocLabel(staff) != '')
                              ? (_openBlock(), _createBlock(_component_NrTooltip, {
                                  key: 0,
                                  label: $options.staffDepartmentsWithPocLabel(staff)
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_8, _toDisplayString($options.staffNameOrEmail(staff)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($options.staffNameOrEmail(staff)), 1))
                          ]))
                        : (!staff.undeliverable_email)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($options.staffNameOrEmail(staff)), 1))
                          : _createCommentVNode("", true),
                    ($options.canAddAndRemoveStaff)
                      ? (_openBlock(), _createBlock(_component_NrTooltip, {
                          key: 3,
                          label: "Remove Staff"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NrIconButton, {
                              class: "edit-request-assigned-btn",
                              variant: "minimal-neutral",
                              icon: { name: 'trash-alt', type: 'regular' },
                              onClick: ($event: any) => ($options.handleRemoveStaffClick(staff)),
                              "aria-label": "Remove staff"
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                _createVNode(_component_NrModal, {
                  class: "remove-staff-modal",
                  modelValue: $data.selectedStaff,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.selectedStaff) = $event)),
                  title: "Remove Staff",
                  show: $data.showRemoveStaffModal,
                  hasSecondaryButton: true,
                  secondaryButtonText: "Cancel",
                  primaryButtonText: "Remove",
                  disableButtons: $options.disableRemoveStaffButton,
                  onOnPrimaryClick: $options.submitRemoveStaff,
                  onOnSecondaryClick: $options.hideRemoveStaffModal,
                  onOnCloseClick: $options.hideRemoveStaffModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.removeStaffDisplayText), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "show", "disableButtons", "onOnPrimaryClick", "onOnSecondaryClick", "onOnCloseClick"]),
                _createElementVNode("div", null, [
                  ($data.showAddStaffModal)
                    ? (_openBlock(), _createBlock(_component_message_box, {
                        key: 0,
                        title: "Add Staff",
                        type: "default",
                        "submit-text": "Add Staff",
                        "disable-submit": false,
                        onOnClose: $options.hideAddStaffModal,
                        onOnCancel: $options.hideAddStaffModal,
                        onOnSubmit: $options.submitAddStaff
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_NrSelect, {
                              class: "m-top-12",
                              modelValue: $data.addStaffToRequest,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.addStaffToRequest) = $event)),
                              placeholder: "Search names or emails",
                              options: $options.filteredStaff,
                              onLoadMore: $options.handleStaffScroll,
                              onSearch: $options.filterStaff,
                              onOpen: $options.filterStaff,
                              multiple: "",
                              loading: _ctx.dataFetchState.staff.fetching,
                              hasMore: !_ctx.dataFetchState.staff.end
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode("Search staff")
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "onLoadMore", "onSearch", "onOpen", "loading", "hasMore"]),
                            _createElementVNode("label", null, [
                              _hoisted_12,
                              _createVNode(_component_nr_editor, {
                                modelValue: $data.message,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.message) = $event)),
                                resizable: false,
                                bold: false,
                                underline: false,
                                italic: false,
                                class: "add-staff-modal",
                                placeholder: 'Send an optional message to inform staff why they are being assigned to this request',
                                rows: 10
                              }, null, 8, ["modelValue"])
                            ]),
                            ($data.message)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_NrFormInput, {
                                    type: "checkbox",
                                    label: "Send to all assigned staff",
                                    name: "send_all_assigned_staff",
                                    modelValue: $data.sendAllAssignedStaff,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.sendAllAssignedStaff) = $event))
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onOnClose", "onOnCancel", "onOnSubmit"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
          key: 1,
          count: 3
        }))
  ]))
}